export default __webpack_public_path__ + "static/media/loungers.c8f699da.svg";